import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import { BUILDERS } from "../../data/km";

export default function BuilderTeaser() {
  return (
  <section id="builders" className="scroll-mt-[84px] bg-[#141414] text-white px-6 md:px-12 lg:px-16 py-12 sm:py-16" data-testid="km-builder-teaser">
    <div className="reveal max-w-[1180px] mx-auto flex flex-col md:flex-row md:items-center justify-between gap-6 md:gap-12">
      <div>
        <p className="km-eyebrow text-[10px] lg:text-[12px] text-white/60 mb-3">For Builders</p>
        <h2 className="km-serif text-[32px] sm:text-[44px] leading-[1.05]">New construction, <em>beautifully sold.</em></h2>
        <p className="km-serif italic text-[18px] sm:text-[21px] text-white/75 mt-3 max-w-[560px]">{BUILDERS.teaser}</p>
        <a href={BUILDERS.cases[0].pdf} download className="inline-flex items-center gap-1.5 km-eyebrow text-[10px] text-white border-b border-white/50 hover:border-white pt-4 pb-1 transition-colors" data-testid="builder-teaser-case">Case study: {BUILDERS.cases[0].title}, {BUILDERS.cases[0].tagline.replace(".", "")} <Download size={12} strokeWidth={1.5} /></a>
      </div>
      <Link to="/contact?interest=Builder%20Partnership" className="km-btn-light gap-2 shrink-0 self-start md:self-auto" data-testid="builder-partner-cta">Partner with Kristin <ArrowRight size={14} strokeWidth={1.5} /></Link>
    </div>
  </section>
  );
}
